import axios from "axios";
import API_URL from "../config";

export const getPrecioResiduo = async () => {
  try {
    const response = await axios.get(
      `${API_URL.Api}/precioResiduo/getPrecioResiduo`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error obteniendo tabla precios residuos",
      error
    );

    return [];
  }
};

export const updatePrecioResiduo = async (
  datosActualizados
) => {};

export const importarPrecios = async (formData) => {
  try {
    const response = await axios.post(
      `${API_URL.Api}/precios/imagen`,
      formData
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error importando precios",
      error
    );

    throw error;
  }
};